import { useCallback, useEffect } from 'react';

// local imports
import { PharmacyService } from 'app/services';
import useDataApi from '../../../use-data-api';

const usePharmacyUserDetailService = (pharmacyId, pharmacyUserId) => {
  const [service, setService] = useDataApi();

  const fetchData = useCallback(async () => {
    // pharmacy user details
    const pharmacyUserDetail = await PharmacyService.getPharmacyUserDetail(
      pharmacyId,
      pharmacyUserId
    );
    const pharmacyUserDetailData = pharmacyUserDetail?.data?.data;

    const { ...rest } = pharmacyUserDetailData;

    return {
      ...rest
    };
  }, [pharmacyId, pharmacyUserId]);

  useEffect(() => setService(() => fetchData()), [fetchData, setService]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default usePharmacyUserDetailService;
